import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryOrganizersParams, queryOrganizers } from "supabase/organizers";

export const useQueryOrganizers = (params: QueryOrganizersParams) => {
  const { name, page, perPage, activeOnly } = params;

  const { isLoading, isError, error, data } = useQuery({
    queryKey: ["organizers", { name, page, activeOnly }],
    queryFn: () => {
      return queryOrganizers({
        name,
        page,
        perPage,
        activeOnly,
      });
    },
    placeholderData: keepPreviousData,
  });

  return {
    isLoading,
    isError,
    error,
    count: data?.count,
    organizers: data?.organizers,
  };
};
